import React, { Component } from "react";
import { connect } from "react-redux";
import ReactJkMusicPlayer from "react-jinke-music-player";
import "react-jinke-music-player/assets/index.css";
import FaHeadphones from 'react-icons/lib/fa/headphones'

const options = {
    defaultPlayIndex: 0,
    theme: 'dark',
    clearPriorAudioLists: false,
    autoPlayInitLoadPlayList: false,
    preload: true,
    glassBg: true,
    remember: true,
    defaultPlayMode: 'order',
    mode: 'full',
    once: false,
    autoPlay: false,
    toggleMode: false,
    seeked: true,
    controllerTitle: <FaHeadphones />,
    showProgressLoadBar: true,
    showPlay: true,
    showReload: true,
    showDownload: false,
    showPlayMode: true,
    showThemeSwitch: false,
    showLyric: false,
    showDestroy: false,
    defaultVolume: 1,
    playModeShowTime: 600,
    loadAudioErrorPlayNext: true,
    autoHiddenCover: false,
    spaceBar: true,
    //Music is downloaded handle
    onAudioDownload(audioInfo) {
      console.log('audio download', audioInfo)
    },
    //audio play handle
    onAudioPlay(audioInfo) {
      console.log('audio playing', audioInfo)
    },
  
    //audio pause handle
    onAudioPause(audioInfo) {
      console.log('audio pause', audioInfo)
    },
  
    //When the user has moved/jumped to a new location in audio
    onAudioSeeked(audioInfo) {
      console.log('audio seeked', audioInfo)
    },
  
    //When the volume has changed  min = 0.0  max = 1.0
    onAudioVolumeChange(currentVolume) {
      console.log('audio volume change', currentVolume)
    },
  
    //The single song is ended handle
    onAudioEnded(currentPlayId, audioLists, audioInfo) {
      console.log('audio ended', currentPlayId, audioLists, audioInfo)
    },
  
    //audio load abort
    onAudioAbort(currentPlayId, audioLists, audioInfo) {
      console.log('audio abort', currentPlayId, audioLists, audioInfo)
    },
  
    //audio play progress handle
    onAudioProgress(audioInfo) {
      // console.log('audio progress',audioInfo);
    },
  
    //audio reload handle
    onAudioReload(audioInfo) {
      console.log('audio reload:', audioInfo)
    },
  
    //audio load failed error handle
    onAudioLoadError(errMsg, currentPlayId, audioLists, audioInfo) {
      console.error(
        'audio load error',
        errMsg,
        currentPlayId,
        audioLists,
        audioInfo
      )
    },
  
    onAudioListsChange(currentPlayId, audioLists, audioInfo) {
      console.log('[currentPlayId] audio lists change:', currentPlayId)
      console.log('[audioLists] audio lists change:', audioLists)
      console.log('[audioInfo] audio lists change:', audioInfo)
    },
  
    onAudioPlayTrackChange(currentPlayId, audioLists, audioInfo) {
      console.log(
        'audio play track change:',
        currentPlayId,
        audioLists,
        audioInfo
      )
    },
  
    onPlayModeChange(playMode) {
      console.log('play mode change:', playMode)
    },
  
    onModeChange(mode) {
      console.log('mode change:', mode)
    },
  
    onAudioListsPanelChange(panelVisible) {
      console.log('audio lists panel visible:', panelVisible)
    },
  
    onAudioListsDragEnd(fromIndex, endIndex) {
      console.log('audio lists drag end:', fromIndex, endIndex)
    },
  
    onAudioLyricChange(lineNum, currentLyric) {
      // console.log('audio lyric change:', lineNum, currentLyric)
    },
  
    // custom music player root node
    getContainer() {
      return document.body
    },
  
    onBeforeDestroy(currentPlayId, audioLists, audioInfo) {
      console.log('currentPlayId: ', currentPlayId)
      console.log('audioLists: ', audioLists)
      console.log('audioInfo: ', audioInfo)
      return new Promise((resolve, reject) => {
        // your custom validate
        if (window.confirm('Are you confirm destroy the player?')) {
          // if resolve, player destroyed
          resolve()
        } else {
          // if reject, skip.
          reject()
        }
      })
    },
  
    onDestroyed(currentPlayId, audioLists, audioInfo) {
      console.log('onDestroyed:', currentPlayId, audioLists, audioInfo)
    }
  }
  
  
class AudioPlayer extends Component {



    constructor(props) {
		super(props);
		this.state = {
           
            params: {
                ...options,
                audioLists: this.props.audioList,
                onAudioPlay: this.props.audioPlay,
                getAudioInstance: (audio) => {
                  this.audio = audio
                }
        }
        }
    }

    play = () => {
      this.audio.play();
    }

    componentDidMount() {
      this.props.setClick(this.play);

    }
    

	render() {
        const { params } = this.state

		return (
			<React.Fragment>
                <ReactJkMusicPlayer  {...params} />

			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
	};
};

export default connect(mapStateToProps)(AudioPlayer);
